var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "medical-analyses" },
    [
      _c(
        "div",
        { staticClass: "layout" },
        [
          _c("reference-header", {
            attrs: {
              "header-title": "Медицинские анализы",
              "create-new-type-label": "Новый тип",
              "create-new-item-label": "Новый анализ",
              "create-new-item-action": _vm.createMedicalAnalyse,
              "create-new-type-action": _vm.createAnalyseType,
            },
          }),
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "medical-analyses-page__search" },
                [
                  _c("c-input", {
                    attrs: {
                      placeholder: "Поиск",
                      type: "text",
                      clearable: true,
                      icon: "search",
                    },
                    model: {
                      value: _vm.query,
                      callback: function ($$v) {
                        _vm.query = $$v
                      },
                      expression: "query",
                    },
                  }),
                ],
                1
              ),
              _c("medical-analyses-list", {
                ref: "list",
                attrs: { query: _vm.query },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("to-top-button", { attrs: { element: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }